import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import { SelectorComponent } from "@components/selector/selector.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";
import { CommandService } from "~app/common/services/cqs/command.service";
import { FordelaService } from "~app/common/services/fordela.service";
import { OverenskommentKvantitetCommandFactory } from "~app/features/justera-leveransplan/common/commands/setOverenskommenKvantitetCommands";
import { AddForsorjningskallaCommandFactory } from "../../../common/add-forsorjningskalla";
import { KundorderService } from "../../../kundorder.service";
import { KundorderradAggregat } from "../kor-hot/kor-hot.model";

@Component({
    selector: "rask-kor-forsorjningsrad-create",
    templateUrl: "./kor-forsorjningsrad-create.component.html",
    styleUrls: ["./kor-forsorjningsrad-create.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        SelectorComponent,
        InputNumberComponent,
        ButtonComponent,
        TranslatePipe
    ]
})
export class KorForsorjningsradCreateComponent {
    form = new UntypedFormGroup({
        forsorjningskalla: new UntypedFormControl(),
        totalKvantitet: new UntypedFormControl()
    });
    kundorderrad: KundorderradAggregat;
    modal = inject(NgbActiveModal);

    private readonly commandService = inject(CommandService);
    private readonly fordelaKvantitetService = inject(FordelaService);
    private readonly kundorderService = inject(KundorderService);

    create() {
        const forsorjningskalla = this.form.get("forsorjningskalla").value;
        const totalKvantitet = this.form.get("totalKvantitet").value;

        const periodStart = this.kundorderrad.periodFrom;
        const periodEnd = this.kundorderrad.periodTom;

        if (!forsorjningskalla) {
            this.modal.dismiss();
            return;
        }

        forsorjningskalla.kvantitet = totalKvantitet;

        this.fordelaKvantitetService.getFordeladKvantitet(totalKvantitet, periodStart, periodEnd)
            .subscribe(result => {
                const model = this.kundorderrad.addForsorjningskalla(forsorjningskalla, result);
                if (!model) {
                    this.modal.close(false);
                    return;
                }

                this.commandService.addTransactionCommand(
                    AddForsorjningskallaCommandFactory.create(model, this.kundorderrad.kundorderradId, result));

                if (totalKvantitet) {
                    this.commandService.addTransactionCommand(
                        OverenskommentKvantitetCommandFactory.createSetOverenskommentKvantitetCommand(model, this.kundorderrad.kundorderradId, totalKvantitet));
                }

                this.modal.close(true);
            });
    }

    dismiss() {
        this.modal.dismiss();
    }

    forsorjningskallaFormatter = result => result ? result.namn : undefined;

    searchForsorjningskalla = (searchStr: string) => {
        const request = {
            input: searchStr,
            mattslag: this.kundorderrad.mattslag,
            periodFrom: this.kundorderrad.periodFrom,
            periodTom: this.kundorderrad.periodTom,
            handelssortimentId: this.kundorderrad.handelssortimentId
        };

        return this.kundorderService.searchForsorjningskalla(request, this.kundorderrad.hasForsorjningskalla);
    };
}
